// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Home1.css */
@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    font-family: 'Bezier Sans Bold';
    src:
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }
  
.switchpage {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;
}

.switchpage-buttons-container {
    display: flex;
    gap: 15px; /* Space between buttons */
}

.switchpage-button {
    height: 40px;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Bezier Sans', sans-serif;
    background-color: #0080ff; /* Adjust color as needed */
    color: #fff;
    border: none;
    border-radius: 15px;
}

.switchpage-button:hover {
    background-color: #0014ff; /* Adjust hover color as needed */
}

@media (max-width: 768px) {

    .switchpage-buttons-container {
        width: 100%;
        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */
        align-items: center;
        padding: 12px 12px;
        
    }
    .switchpage-button {
        width: 90%;
        padding: 12px 24px; /* Slightly larger padding for mobile devices */
        font-size: 14px; /* Increase font size for readability on smaller screens */
        height: auto;
        text-align: center; /* Center text within buttons */
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/SwitchPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;IAElB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;;AAEF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS,EAAE,0BAA0B;AACzC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,yBAAyB,EAAE,2BAA2B;IACtD,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,iCAAiC;AAChE;;AAEA;;IAEI;QACI,WAAW;QACX,sBAAsB,EAAE,4DAA4D;QACpF,mBAAmB;QACnB,kBAAkB;;IAEtB;IACA;QACI,UAAU;QACV,kBAAkB,EAAE,+CAA+C;QACnE,eAAe,EAAE,0DAA0D;QAC3E,YAAY;QACZ,kBAAkB,EAAE,+BAA+B;IACvD;AACJ","sourcesContent":["/* src/styles/Home1.css */\r\n@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    font-family: 'Bezier Sans Bold';\r\n    src:\r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n  \r\n.switchpage {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-bottom: 5%;\r\n}\r\n\r\n.switchpage-buttons-container {\r\n    display: flex;\r\n    gap: 15px; /* Space between buttons */\r\n}\r\n\r\n.switchpage-button {\r\n    height: 40px;\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    background-color: #0080ff; /* Adjust color as needed */\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 15px;\r\n}\r\n\r\n.switchpage-button:hover {\r\n    background-color: #0014ff; /* Adjust hover color as needed */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n    .switchpage-buttons-container {\r\n        width: 100%;\r\n        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */\r\n        align-items: center;\r\n        padding: 12px 12px;\r\n        \r\n    }\r\n    .switchpage-button {\r\n        width: 90%;\r\n        padding: 12px 24px; /* Slightly larger padding for mobile devices */\r\n        font-size: 14px; /* Increase font size for readability on smaller screens */\r\n        height: auto;\r\n        text-align: center; /* Center text within buttons */\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
